"use client";

interface EmpoweringFeaturesProps {
  introText?: {
    text: string;
    highlights?: { text: string; highlighted: boolean }[];
  };
  empoweringTitle?: string;
  empoweringFeatures?: {
    column1?: string[];
    column2?: string[];
    column3?: string[];
  };
}

export default function EmpoweringFeatures({
  introText,
  empoweringTitle,
  empoweringFeatures,
}: EmpoweringFeaturesProps) {
  // Don't render if no content
  if (!introText && !empoweringTitle && !empoweringFeatures) {
    return null;
  }

  return (
    <section className="w-full bg-white pt-[60px] 2xl:pt-[150px] px-4 md:px-8 lg:px-[100px]">
      <div className="max-w-[5000px] mx-auto">
        <div className="flex flex-col gap-[30px] md:gap-[40px] lg:gap-[54px]">
          {/* Main Intro Paragraph */}
          {introText && (
            <div className="w-full">
              <p className="text-[clamp(1.25rem,0.6957rem+1.1547vw,2.5rem)] font-normal leading-[170%] text-[#00040b]">
                {introText.highlights
                  ? introText.highlights?.map((part, idx) =>
                      part.highlighted ? (
                        <span key={idx} className="text-[#225bd4] font-medium">
                          {part.text}
                        </span>
                      ) : (
                        <span key={idx}>{part.text}</span>
                      ),
                    )
                  : introText.text}
              </p>
            </div>
          )}

          {/* Empowering Section */}
          {(empoweringTitle || empoweringFeatures) && (
            <div className="flex flex-col gap-[20px] md:gap-[25px] lg:gap-[30px]">
              {empoweringTitle && (
                <h2 className="text-[22px] md:text-[28px] lg:text-[34px] font-medium clash-font text-[#00040b]">
                  {empoweringTitle}
                </h2>
              )}

              {/* Three Column List */}
              {empoweringFeatures && (
                <div className="flex flex-col md:flex-row gap-[20px] md:gap-0 w-full">
                  {/* Column 1 */}
                  {empoweringFeatures.column1 &&
                    empoweringFeatures.column1.length > 0 && (
                      <div className="flex-1 flex flex-col gap-[12px] md:gap-[15px] xl:py-[0px] py-[15px]">
                        {empoweringFeatures.column1?.map((item, idx) => (
                          <p
                            key={idx}
                            className="text-[16px] md:text-[18px] lg:text-[20px] font-medium italic text-[#00040b] leading-[140%]"
                          >
                            • {item}
                          </p>
                        ))}
                      </div>
                    )}

                  {/* Column 2 */}
                  {empoweringFeatures.column2 &&
                    empoweringFeatures.column2.length > 0 && (
                      <div className="flex-1 flex flex-col gap-[12px] md:gap-[15px]  xl:pt-[0px] pt-[15px]">
                        {empoweringFeatures.column2?.map((item, idx) => (
                          <p
                            key={idx}
                            className="text-[16px] md:text-[18px] lg:text-[20px] font-medium italic text-[#00040b] leading-[140%]"
                          >
                            • {item}
                          </p>
                        ))}
                      </div>
                    )}

                  {/* Column 3 */}
                  {empoweringFeatures.column3 &&
                    empoweringFeatures.column3.length > 0 && (
                      <div className="flex-1 flex flex-col gap-[12px] md:gap-[15px]  xl:pt-[0px] pt-[15px]">
                        {empoweringFeatures.column3?.map((item, idx) => (
                          <p
                            key={idx}
                            className="text-[16px] md:text-[18px] lg:text-[20px] font-medium italic text-[#00040b] leading-[140%]"
                          >
                            • {item}
                          </p>
                        ))}
                      </div>
                    )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
